/**
 * ReactFlow nodeTypes registration for attack paths graph.
 *
 * Maps node type strings to their React components.
 * Used by ReactFlow to render custom node types.
 */

import {
  AssetNode,
  AttackerNode,
  TechniqueNode,
  VulnerabilityNode,
} from '@/sections/attacks/attackPaths/components/nodes';

/**
 * Node type registry for attack path visualization.
 */
export const nodeTypes = {
  asset: AssetNode,
  attacker: AttackerNode,
  technique: TechniqueNode,
  vulnerability: VulnerabilityNode,
};
